import { render, staticRenderFns } from "./LocationView.vue?vue&type=template&id=99d70e10"
import script from "./LocationView.vue?vue&type=script&lang=ts"
export * from "./LocationView.vue?vue&type=script&lang=ts"
import style0 from "./LocationView.vue?vue&type=style&index=0&id=99d70e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports